import articleTmpl from '../article-card/article-card.twig';
import axios from 'axios';
import {debounce} from 'throttle-debounce';
import Utils from '../../common/scripts/utils';

class TagsForm {
    constructor() {
        /**
         * Форма с тэгами
         * @type {Element}
         */
        this.form = null;

        /**
         * Данные формы для запросов
         */
        this.formData = null;

        /**
         * Обёртка где будет отрисовываться контент
         * @type {Element}
         */
        this.contentWrapper = null;

        /**
         * Адрес запросов
         * @type {String}
         */
        this.action = null;

        /**
         * Кнопка "Подгрузить ещё"
         * @type {Element}
         */
        this.moreBtn = null;

        /**
         * Дефолтный класс элементов которые отображаем
         * @type {string}
         */
        this.defaultItemClass = '.j-article-item';

        /**
         * Класс элементов которые отображаем (нужен для очистки элементов)
         * @type {string}
         */
        this.itemClass = null;

        /**
         * Шаблон вывода контента
         */
        this.template = null;

        /**
         * Инпуты/тэги
         */
        this.inputs = null;
    }

    /**
     * Инициализирует модуль
     * @param {object} options - настройки
     */
    init(options) {
        this._initElements(options);
        this._setTemplate(options);
        this._bindEvents();
        this._checkState();
    }

    /**
     * Инициаизирует элементы
     * @param {object} options - настройки
     * @private
     */
    _initElements(options) {
        this.contentWrapper = options.contentWrapper;
        this.moreBtn = options.moreBtn;
        this.form = options.form;
        this.itemClass = options.itemClass || this.defaultItemClass;
        this.action = this.form.getAttribute('action');
        this.inputs = Array.from(this.form.querySelectorAll('input'));
    }

    /**
     * Проверяет начальное состояние тегов
     * @private
     */
    _checkState() {
        const urlParams = Utils.getUrlParams('tag');

        if (!urlParams) {
            return;
        }

        const arr = urlParams.split(',');

        this.inputs.forEach((input) => {
            const name = input.name.match(/\[(.*)\]/)[1];

            if (!arr.includes(name)) {
                return;
            }

            input.checked = true;
        });

        this._send();
    }

    /**
     * Устанавливает шаблон вывода данных
     * @param {object} options - настройки
     * @private
     */
    _setTemplate(options) {
        this.template = options.template || articleTmpl;
    }

    /**
     * Навешивает обработчики событий
     * @private
     */
    _bindEvents() {
        this.form.addEventListener('submit', (evt) => {
            evt.preventDefault();
        });

        this.form.addEventListener('change', debounce(10, () => {
            this._setUrlParams();
            this._send();
        }));
    }

    /**
     * Устанавливает выбранные теги в url
     * @private
     */
    _setUrlParams() {
        const activeTags = this._getActiveTags();

        if (!activeTags.length) {
            Utils.deleteUrlParams('tag');

            return;
        }

        const list = activeTags.join(',');

        Utils.setUrlParams([{
            param: 'tag',
            value: list
        }]);
    }

    /**
     * Получает выбранные теги
     * @return {array} - массив выбранных тегов
     * @private
     */
    _getActiveTags() {
        const arr = [];

        this.inputs.forEach((input) => {
            if (!input.checked) {
                return;
            }

            // получаем значение между квадратными скобочками []
            const name = input.name.match(/\[(.*)\]/)[1];

            arr.push(name);
        });

        return arr;
    }

    /**
     * Подготавливает форм-дату
     * @private
     */
    _send() {
        this.formData = new FormData(this.form);
        this._disableMore();

        axios.post(this.action, this.formData)
            .then((response) => {
                const {data} = response;
                const status = data.request.status;

                if (status) {
                    this._removeAllItems();
                    this._checkLastPage(data.data.more);
                    this._makeNewArticles(data);
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                this._enableMore();
            });
    }

    /**
     * Отрисовывает и вставляет в контейнер
     * @param {object} data - данные для отрисовки
     * @private
     */
    _makeNewArticles(data) {
        const dataItems = data.data.items;
        const markup = this.template({items: dataItems});

        Utils.insetContentBefore(this.contentWrapper, markup);
    }

    /**
     * Очищает контейнер
     * @private
     */
    _removeAllItems() {
        const items = Array.from(document.querySelectorAll(this.itemClass));

        items.forEach((item) => {
            Utils.removeElement(item);
        });
    }

    /**
     * Проверяем есть ли что подгрузить и скрываем кнопку
     * @param {boolean} state - состояние
     * @private
     */
    _checkLastPage(state) {
        if (!this.moreBtn) {
            return;
        }

        this.moreBtn.style.display = state ? 'block' : 'none';
    }

    /**
     * Деакцтивирует кнопку подгрузки
     * @private
     */
    _disableMore() {
        if (!this.moreBtn) {
            return;
        }

        this.moreBtn.classList.add('is-disabled');
    }

    /**
     * Активирует кнопку подгрузки
     * @private
     */
    _enableMore() {
        if (!this.moreBtn) {
            return;
        }

        this.moreBtn.classList.remove('is-disabled');
    }
}

export default TagsForm;
